export class PromiseStatus {
    private readonly status: PromiseStatusEnum;

    constructor(status: PromiseStatusEnum) {
        this.status = status;
    }

    public succeeded = (): boolean => this.status === PromiseStatusEnum.SUCCEEDED;
    public failed = (): boolean => this.status === PromiseStatusEnum.FAILED;
    public pending = (): boolean => this.status === PromiseStatusEnum.PENDING;
    public initialized = (): boolean => this.status === PromiseStatusEnum.INITIALIZED;
}

export enum PromiseStatusEnum {
    INITIALIZED = 'INITIALIZED',
    PENDING = 'PENDING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED'
}
